import { observer } from 'mobx-react';
import React, { useCallback, useRef } from 'react';

import useIsMobile from 'hooks/use-is-mobile';
import DrawerMenuButton from 'pages/layout/components/DrawerMenuButton';
import Logo from 'pages/layout/components/Logo';
import SearchBar from 'pages/layout/components/SearchBar';
import SearchDialogButton from 'pages/layout/components/SearchDialogButton';
import UpgradeLicenseButton from 'pages/layout/components/UpgradeLicenseButton';

import useStyles from './styles';

interface Props {
    className?: string;
}

const Header: React.FC<Props> = ({ className }) => {
    const isMobile = useIsMobile();
    const { classes, cx } = useStyles();
    const containerRef = useRef<HTMLDivElement | null>(null);
    const container = useCallback(() => containerRef.current!, [containerRef]);

    return (
        <div className={cx(classes.container, className)} ref={containerRef}>
            <Logo className={classes.logo} />
            {isMobile ? (
                <>
                    <SearchDialogButton className={classes.margined} container={container} />
                    <DrawerMenuButton className={classes.margined} container={container} />
                </>
            ) : (
                <>
                    <SearchBar variant="desktop" className={classes.margined} />
                    <UpgradeLicenseButton className={classes.margined} />
                </>
            )}
        </div>
    );
};

export default observer(Header);
